import { c as _c } from "react/compiler-runtime";
import { fetchBjLevel, fetchEventHeartList, fetchGlobalHeartList, fetchHeartChargeList, fetchHeartFreeList, fetchHeartInfo, fetchHeartSumList, fetchHeartUseList, fetchHoldHeartDetailList, fetchHoldHeartList, fetchUserGiftChartData, fetchUserGiftList } from '@module/apis/client-side/heart';
import type { EventHeartListParams, EventHeartListResponse, FetchBjLevelResponse, FetchHeartChargeListResponse, FetchHeartInfoParams, FetchHeartInfoResponse, FetchHeartSumListResponse, FetchHeartUseListResponse, GlobalHeartListParams, GlobalHeartListResponse, HoldHeartDetailListParams, HoldHeartDetailListResponse, HoldHeartListParams, HoldHeartListResponse, UserGiftListParams, UserGiftListResponse, UserGiftStatParams, UserGiftStatResponse } from '@module/apis/client-side/heart/type';
import type { PageListParams } from '@module/apis/type';
import { keepPreviousData, type UseInfiniteQueryOptions, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import TimeConstants from '../../utils/item';
import type { CustomUseQueryOptions } from '../type';
import { heartQueryKeys } from './heartQuerykeys';
export const useFetchHeartInfoQuery = (fetchHeartInfoParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchHeartInfoParams) {
    t0 = heartQueryKeys.fetchHeartInfo(fetchHeartInfoParams);
    $[0] = fetchHeartInfoParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchHeartInfoParams) {
    t1 = () => fetchHeartInfo(fetchHeartInfoParams);
    $[2] = fetchHeartInfoParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      staleTime: TimeConstants.FIVE_MINUTES,
      ...options,
      placeholderData: keepPreviousData
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchHeartUseListQuery = (fetchHeartUseListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchHeartUseListParams) {
    t0 = heartQueryKeys.fetchHeartUseList(fetchHeartUseListParams);
    $[0] = fetchHeartUseListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchHeartUseListParams) {
    t1 = () => fetchHeartUseList(fetchHeartUseListParams);
    $[2] = fetchHeartUseListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchHeartUseListInfiniteQuery = (fetchHeartUseListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchHeartUseListParams) {
    t0 = heartQueryKeys.fetchHeartUseList(fetchHeartUseListParams);
    $[0] = fetchHeartUseListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchHeartUseListParams) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = fetchHeartUseListParams.limit * ((actualPageParam || 1) - 1);
      return fetchHeartUseList({
        ...fetchHeartUseListParams,
        offset
      });
    };
    $[2] = fetchHeartUseListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp2,
      select: _temp4
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchHeartChargeListQuery = (fetchHeartChargeListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchHeartChargeListParams) {
    t0 = heartQueryKeys.fetchHeartChargeList(fetchHeartChargeListParams);
    $[0] = fetchHeartChargeListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchHeartChargeListParams) {
    t1 = () => fetchHeartChargeList(fetchHeartChargeListParams);
    $[2] = fetchHeartChargeListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchHeartChargeListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = heartQueryKeys.fetchHeartChargeList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchHeartChargeList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp6,
      select: _temp8
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchHeartSumListQuery = (fetchHeartSumListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchHeartSumListParams) {
    t0 = heartQueryKeys.fetchHeartSumList(fetchHeartSumListParams);
    $[0] = fetchHeartSumListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchHeartSumListParams) {
    t1 = () => fetchHeartSumList(fetchHeartSumListParams);
    $[2] = fetchHeartSumListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchHeartSumListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = heartQueryKeys.fetchHeartSumList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchHeartSumList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp10,
      select: _temp12
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchHeartFreeListQuery = (fetchHeartFreeListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchHeartFreeListParams) {
    t0 = heartQueryKeys.fetchHeartFreeList(fetchHeartFreeListParams);
    $[0] = fetchHeartFreeListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchHeartFreeListParams) {
    t1 = () => fetchHeartFreeList(fetchHeartFreeListParams);
    $[2] = fetchHeartFreeListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchHeartFreeListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = heartQueryKeys.fetchHeartFreeList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchHeartFreeList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp14,
      select: _temp16
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchBjLevelQuery = (fetchBjLevelParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchBjLevelParams) {
    t0 = heartQueryKeys.fetchBjLevel(fetchBjLevelParams);
    $[0] = fetchBjLevelParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchBjLevelParams) {
    t1 = () => fetchBjLevel(fetchBjLevelParams);
    $[2] = fetchBjLevelParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchUserGiftChartDataQuery = (fetchUserGiftStatParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchUserGiftStatParams) {
    t0 = heartQueryKeys.fetchUserGiftChartData(fetchUserGiftStatParams);
    $[0] = fetchUserGiftStatParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchUserGiftStatParams) {
    t1 = () => fetchUserGiftChartData(fetchUserGiftStatParams);
    $[2] = fetchUserGiftStatParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      staleTime: TimeConstants.ONE_MINUTE,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchUserGiftListQuery = (fetchUserGiftListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchUserGiftListParams) {
    t0 = heartQueryKeys.fetchUserGiftList(fetchUserGiftListParams);
    $[0] = fetchUserGiftListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchUserGiftListParams) {
    t1 = () => fetchUserGiftList(fetchUserGiftListParams);
    $[2] = fetchUserGiftListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchGlobalHeartListQuery = (fetchGlobalHeartListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchGlobalHeartListParams) {
    t0 = heartQueryKeys.fetchGlobalHeartList(fetchGlobalHeartListParams);
    $[0] = fetchGlobalHeartListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchGlobalHeartListParams) {
    t1 = () => fetchGlobalHeartList(fetchGlobalHeartListParams);
    $[2] = fetchGlobalHeartListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchGlobalHeartListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = heartQueryKeys.fetchGlobalHeartList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchGlobalHeartList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      staleTime: TimeConstants.ONE_MINUTE,
      ...options,
      getNextPageParam: _temp18,
      select: _temp20
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchUserGiftListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = heartQueryKeys.fetchUserGiftList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchUserGiftList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      staleTime: TimeConstants.ONE_MINUTE,
      ...options,
      getNextPageParam: _temp22,
      select: _temp24
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchEventHeartListQuery = (fetchEventHeartListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchEventHeartListParams) {
    t0 = heartQueryKeys.fetchEventHeartList(fetchEventHeartListParams);
    $[0] = fetchEventHeartListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchEventHeartListParams) {
    t1 = () => fetchEventHeartList(fetchEventHeartListParams);
    $[2] = fetchEventHeartListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchEventHeartListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = heartQueryKeys.fetchEventHeartList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchEventHeartList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      staleTime: TimeConstants.ONE_MINUTE,
      ...options,
      getNextPageParam: _temp26,
      select: _temp28
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchHoldHeartListQuery = (fetchHoldHeartListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchHoldHeartListParams) {
    t0 = heartQueryKeys.fetchHoldHeartList(fetchHoldHeartListParams);
    $[0] = fetchHoldHeartListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchHoldHeartListParams) {
    t1 = () => fetchHoldHeartList(fetchHoldHeartListParams);
    $[2] = fetchHoldHeartListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchHoldHeartListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = heartQueryKeys.fetchHoldHeartList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchHoldHeartList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      staleTime: TimeConstants.ONE_MINUTE,
      ...options,
      getNextPageParam: _temp30,
      select: _temp32
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchHoldHeartDetailListQuery = (fetchHoldHeartDetailListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchHoldHeartDetailListParams) {
    t0 = heartQueryKeys.fetchHoldHeartDetailList(fetchHoldHeartDetailListParams);
    $[0] = fetchHoldHeartDetailListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchHoldHeartDetailListParams) {
    t1 = () => fetchHoldHeartDetailList(fetchHoldHeartDetailListParams);
    $[2] = fetchHoldHeartDetailListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchHoldHeartDetailListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = heartQueryKeys.fetchHoldHeartDetailList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchHoldHeartDetailList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp34,
      select: _temp36
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
function _temp(page) {
  return page.list;
}
function _temp2(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp3(page_0) {
  return page_0.list ?? [];
}
function _temp4(data) {
  return {
    pages: data?.pages.flatMap(_temp3),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp5(page) {
  return page.list;
}
function _temp6(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp5).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp7(page_0) {
  return page_0.list ?? [];
}
function _temp8(data) {
  return {
    pages: data?.pages.flatMap(_temp7),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp9(page) {
  return page.list;
}
function _temp10(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp9).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp11(page_0) {
  return page_0.list ?? [];
}
function _temp12(data) {
  return {
    pages: data?.pages.flatMap(_temp11),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp13(page) {
  return page.list;
}
function _temp14(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp13).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp15(page_0) {
  return page_0.list ?? [];
}
function _temp16(data) {
  return {
    pages: data?.pages.flatMap(_temp15),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp17(page) {
  return page.list;
}
function _temp18(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp17).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp19(page_0) {
  return page_0.list ?? [];
}
function _temp20(data) {
  return {
    pages: data?.pages.flatMap(_temp19),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp21(page) {
  return page.list;
}
function _temp22(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp21).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp23(page_0) {
  return page_0.list ?? [];
}
function _temp24(data) {
  return {
    pages: data?.pages.flatMap(_temp23),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp25(page) {
  return page.list;
}
function _temp26(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp25).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp27(page_0) {
  return page_0.list ?? [];
}
function _temp28(data) {
  return {
    pages: data?.pages.flatMap(_temp27),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp29(page) {
  return page.list;
}
function _temp30(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp29).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp31(page_0) {
  return page_0.list ?? [];
}
function _temp32(data) {
  return {
    pages: data?.pages.flatMap(_temp31),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp33(page) {
  return page.list;
}
function _temp34(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp33).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp35(page_0) {
  return page_0.list ?? [];
}
function _temp36(data) {
  return {
    pages: data?.pages.flatMap(_temp35),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}